import { NgModule } from '@angular/core';
import { PreloadAllModules, Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'list',
    loadChildren: () =>
      import('./list/list.module').then((m) => m.ListPageModule),
  },
  {
    path: 'projects',
    loadChildren: () =>
      import('./projects/projects.module').then((m) => m.ProjectsPageModule),
  },
  {
    path: 'project/:id',
    loadChildren: () =>
      import('./project/project.module').then((m) => m.ProjectPageModule),
  },
  {
    path: 'building/:id',
    loadChildren: () =>
      import('./building/building.module').then((m) => m.BuildingPageModule),
  },
  {
    path: 'sketch/:id',
    loadChildren: () =>
      import('./sketch/sketch.module').then((m) => m.SketchPageModule),
  },
  {
    path: 'sketch-relocate/:id/:damage',
    loadChildren: () =>
      import('./sketch-relocate/sketch-relocate.module').then(
        (m) => m.SketchRelocatePageModule
      ),
  },
  {
    path: 'damages/:id',
    loadChildren: () =>
      import('./damages/damages.module').then((m) => m.DamagesPageModule),
  },
  {
    path: 'damage/:id',
    loadChildren: () =>
      import('./damage/damage.module').then((m) => m.DamagePageModule),
  },
  {
    path: 'note/:id',
    loadChildren: () =>
      import('./note/note.module').then((m) => m.NotePageModule),
  },
  {
    path: 'new-damage/:type/:id',
    loadChildren: () =>
      import('./new-damage/new-damage.module').then(
        (m) => m.NewDamagePageModule
      ),
  },
  {
    path: 'sketch-damages/:id',
    loadChildren: () =>
      import('./sketch-damages/sketch-damages.module').then(
        (m) => m.SketchDamagesPageModule
      ),
  },
  {
    path: 'new-note/:type/:id',
    loadChildren: () =>
      import('./new-note/new-note.module').then((m) => m.NewNotePageModule),
  },
  {
    path: 'examples',
    loadChildren: () =>
      import('./examples/examples.module').then((m) => m.ExamplesPageModule),
  },
  {
    path: 'sync',
    loadChildren: () =>
      import('./sync/sync.module').then((m) => m.SyncPageModule),
  },
  {
    path: 'logout',
    loadChildren: () =>
      import('./logout/logout.module').then((m) => m.LogoutPageModule),
  },
  {
    path: 'faq',
    loadChildren: () => import('./faq/faq.module').then((m) => m.FaqPageModule),
  },
  {
    path: 'draw',
    loadChildren: () =>
      import('./draw/draw.module').then((m) => m.DrawPageModule),
  },
  {
    path: 'sketch-damage/:id/:damage',
    loadChildren: () =>
      import('./sketch-damage/sketch-damage.module').then(
        (m) => m.SketchDamagePageModule
      ),
  },
  {
    path: 'sketch-damage-add/:id/:damage',
    loadChildren: () =>
      import('./sketch-damage-add/sketch-damage-add.module').then(
        (m) => m.SketchDamageAddPageModule
      ),
  },
  {
    path: 'sketch-damage-paint/:id/:damage',
    loadChildren: () =>
      import('./sketch-damage-paint/sketch-damage-paint.module').then(
        (m) => m.SketchDamagePaintPageModule
      ),
  },
  {
    path: 'sketch-pin/:id/:pin',
    loadChildren: () =>
      import('./sketch-pin/sketch-pin.module').then(
        (m) => m.SketchPinPageModule
      ),
  },
  {
    path: 'sketch-pin-add/:id/:pin',
    loadChildren: () =>
      import('./sketch-pin-add/sketch-pin-add.module').then(
        (m) => m.SketchPinAddPageModule
      ),
  },
  {
    path: 'sketch-pin-paint/:id/:pin',
    loadChildren: () =>
      import('./sketch-pin-paint/sketch-pin-paint.module').then(
        (m) => m.SketchPinPaintPageModule
      ),
  },
  {
    path: 'issue-report',
    loadChildren: () =>
      import('./issue-report/issue-report.module').then(
        (m) => m.IssueReportPageModule
      ),
  },
  {
    path: 'feedback',
    loadChildren: () =>
      import('./feedback/feedback.module').then((m) => m.FeedbackPageModule),
  },
  {
    path: 'sketch-note-add/:id/:note',
    loadChildren: () =>
      import('./sketch-note-add/sketch-note-add.module').then(
        (m) => m.SketchNoteAddPageModule
      ),
  },
  {
    path: 'sketch-note-paint/:id/:note',
    loadChildren: () =>
      import('./sketch-note-paint/sketch-note-paint.module').then(
        (m) => m.SketchNotePaintPageModule
      ),
  },
  {
    path: 'sketch-note/:id/:note',
    loadChildren: () =>
      import('./sketch-note/sketch-note.module').then(
        (m) => m.SketchNotePageModule
      ),
  },
  {
    path: 'imprint',
    loadChildren: () =>
      import('./imprint/imprint.module').then((m) => m.ImprintPageModule),
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('./privacy/privacy.module').then((m) => m.PrivacyPageModule),
  },
  {
    path: 'cache',
    loadChildren: () =>
      import('./cache/cache.module').then((m) => m.CachePageModule),
  },
  {
    path: 'damage-reattach/:id',
    loadChildren: () =>
      import('./damage-reattach/damage-reattach.module').then(
        (m) => m.DamageReattachPageModule
      ),
  },
  {
    path: 'ifcviewer/:id/:damage/:force_ifc',
    loadChildren: () =>
      import('./ifcviewer/ifcviewer.module').then((m) => m.IfcviewerPageModule),
  },
  {
    path: 'ifcviewer/:id/:damage',
    loadChildren: () =>
      import('./ifcviewer/ifcviewer.module').then((m) => m.IfcviewerPageModule),
  },
  {
    path: 'pin/:id',
    loadChildren: () => import('./pin/pin.module').then((m) => m.PinPageModule),
  },
  {
    path: 'new-pin/:type/:id',
    loadChildren: () =>
      import('./new-pin/new-pin.module').then((m) => m.NewPinPageModule),
  },
  {
    path: 'building-details/:id',
    loadChildren: () =>
      import('./building-details/building-details.module').then(
        (m) => m.BuildingDetailsPageModule
      ),
  },
  {
    path: 'pin-reattach/:id',
    loadChildren: () =>
      import('./pin-reattach/pin-reattach.module').then(
        (m) => m.PinReattachPageModule
      ),
  },
  {
    path: 'note-reattach/:id',
    loadChildren: () =>
      import('./note-reattach/note-reattach.module').then(
        (m) => m.NoteReattachPageModule
      ),
  },
  {
    path: 'licenses',
    loadChildren: () =>
      import('./licenses/licenses.module').then((m) => m.LicensesPageModule),
  },
  {
    path: 'error-view',
    loadChildren: () =>
      import('./error-view/error-view.module').then(
        (m) => m.ErrorViewPageModule
      ),
  },
  {
    path: 'damage-map/:id',
    loadChildren: () =>
      import('./damage-map/damage-map.module').then(
        (m) => m.DamageMapPageModule
      ),
  },
  {
    path: 'search-select-modal',
    loadChildren: () =>
      import('./search-select-modal/search-select-modal.module').then(
        (m) => m.SearchSelectModalPageModule
      ),
  },
  {
    path: 'icon-paint-modal',
    loadChildren: () =>
      import('./icon-paint-modal/icon-paint-modal.module').then(
        (m) => m.IconPaintModalPageModule
      ),
  },
  {
    path: 'damagetemplates-modal',
    loadChildren: () =>
      import('./damagetemplates-modal/damagetemplates-modal.module').then(
        (m) => m.DamagetemplatesModalPageModule
      ),
  },  {
    path: 'sketch-damages-list-modal',
    loadChildren: () => import('./sketch-damages-list-modal/sketch-damages-list-modal.module').then( m => m.SketchDamagesListModalPageModule)
  },
  {
    path: 'photo-note-modal',
    loadChildren: () => import('./modals/photo-note-modal/photo-note-modal.module').then( m => m.PhotoNoteModalPageModule)
  },
  {
    path: 'marker-type-modal',
    loadChildren: () => import('./modals/marker-type-modal/marker-type-modal.module').then( m => m.MarkerTypeModalPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
